import React from "react";
import CoursePestanasNav from "../components/CoursePestanasNav";
import "./Temario.css";

function Resumenes() {
  return (
    <div className="cds-campus-root">
      <CoursePestanasNav />
      <h2>Sección: Resúmenes</h2>
      <p>Aquí el usuario ve los resúmenes.</p>
    </div>
  );
}

export default Resumenes;
